"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceInformationQueryError = exports.CommonError = exports.AuthenticationError = void 0;
var AuthenticationError;
(function (AuthenticationError) {
    AuthenticationError["wrongPassword"] = "wrongPassword";
    AuthenticationError["emailAddressNotFound"] = "emailAddressNotFound";
    AuthenticationError["invalidToken"] = "invalidToken";
    AuthenticationError["expiredToken"] = "expiredToken";
})(AuthenticationError || (exports.AuthenticationError = AuthenticationError = {}));
var CommonError;
(function (CommonError) {
    CommonError["operationAlreadyCompleted"] = "operationAlreadyCompleted";
})(CommonError || (exports.CommonError = CommonError = {}));
var PlaceInformationQueryError;
(function (PlaceInformationQueryError) {
    PlaceInformationQueryError["placeDisabled"] = "placeDisabled";
})(PlaceInformationQueryError || (exports.PlaceInformationQueryError = PlaceInformationQueryError = {}));
//# sourceMappingURL=Errors.js.map